import React from 'react';

import './Stats.css';

const statsData = [
    { value: '500%', label: 'Average ROI' },
    { value: '150+', label: 'Happy Clients' },
    { value: '2M+', label: 'Monthly Impressions' },
    { value: '98%', label: 'Client Retention' }
];

const Stats = () => {
    return (
        <section className="stats">

            <div className="container">
                <div className="stats-grid">
                    {statsData.map((stat, index) => (
                        <div className="stat-item" key={index}>
                            <h3>{stat.value}</h3>
                            <p>{stat.label}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Stats;
